<template>
    <div class="art-box">
        <ul id="articleList">
            <li v-for="value in articleListData" :dataType="value.type" :data-urlid="value.urlid" :key="value.urlid">
                <div class="info">
                    <h3 v-if="value.type==1"><a :href="value.url">{{value.title}}</a></h3>
                    <h3 v-else @click="canNotView"><a>{{value.title}}</a></h3>

                    <p v-if="value.type==1">
                        {{value.modifytime | dateFormat}} 已发布
                        <span class="operat" @click="popupsLayer(value)">···</span>
                    </p>
                    <p v-if="value.type==2">{{value.modifytime| dateFormat}} 审核中</p>
                    <p v-if="value.type==3">
                        {{value.modifytime| dateFormat}} 未通过
                        <span class="operat" @click="popupsLayer(value)">···</span>
                    </p>
                    <p v-if="value.type==4">
                        {{value.modifytime| dateFormat}} 草稿
                        <span class="operat" @click="popupsLayer(value)">···</span>
                    </p>
                    <p v-if="value.type==5">
                        {{value.modifytime| dateFormat}} 已撤回
                        <span class="operat" @click="popupsLayer(value)">···</span>
                    </p>
                    <p :id="value.urlid">
                        <span><span class="read-icon"></span><span class="readPv">{{value.readpv}}</span></span><i></i>&nbsp;&nbsp;<span><span class="comment-icon"></span><span class="commentPv">{{value.commentpv}}</span></span>
                    </p>
                </div>
                <div class="cover-pic">
                    <!-- <img src="../../assets/img/def.jpg" alt=""> -->
                    <a v-if="value.type==1" :href="value.url">
                        <img :src="value.cover" v-if="value.cover" alt="">
                        <img v-else src="../../assets/img/def.jpg" alt="">
                        </a>
                    <a v-else  @click="canNotView">
                        <img :src="value.cover" alt=""  v-if="value.cover">
                         <img v-else src="../../assets/img/def.jpg" alt="">
                        </a>
                </div>
            </li>
        </ul>
        <Loading v-if="loadingShow"></Loading>
        <NoMore v-if="noData"></NoMore>
    </div>
</template>

<script>
    import {dateFormat} from './../../common/js/util.js'
    import {getmaininfo, getPageview, withdrawcontent, delcontent, deldraftlist, getuserinfo, searchcontent} from './../../axios/api.js'
    import Loading from './../loading.vue'
    import NoMore from './../loadingNoMore.vue'
    let pgno, passType;
    export default {
        data() {
            return {
                articleListData: [],
                loadingShow: false,
                noData: false,
                loadSwitch: true,
                pgno: 1,
            }
        },
        props: [
            'dataType',
        ],
        activated(){
            this.pgno = 1;
        },
        mounted(){
            let that = this;
            this.pgno = 1;
            // 注册scroll事件并监听 
            passType = this.dataType;
            if(passType == '0'){
               passType = "";
            }else if (passType == '1'){
                passType = "已发布";
            }else if (passType == '2'){
                passType = "审核中";
            }else if (passType == '3'){
                passType = "未通过";

            }else if (passType == '4'){
                 passType = "草稿";
            }
            else if (passType == '5'){
                 passType = "已撤回";
            }
            // console.log(this.dataType);
            pgno = this.pgno;
            window.addEventListener('scroll',this.scrollLoadData);
            document.getElementById('loadDataByTitle').onsubmit = function(e){
                e.preventDefault();
                e.stopPropagation();
                let searchTxt = document.querySelector('#loadDataByTitle input').value;
                if(searchTxt == ''){
                    that.$layer.toast({
                        icon: 'icon-tips', // 图标clssName 如果为空 toast位置位于下方,否则居中 
                        className: 'tips',
                        content: '请输入搜索关键字',
                        time: 2000 // 自动消失时间 toast类型默认消失时间为2000毫秒 
                    })
                    return;
                }
                passType = "";
                document.querySelector('.vue-tablist li[aria-selected="true"]').setAttribute('aria-selected', false);
                document.querySelector('.vue-tablist li[role="tab"]').setAttribute('aria-selected', true)
                console.log(document.querySelector('.vue-tablist'));

                that.searchcontent(pgno, searchTxt,)
            }
            this.getmaininfo(pgno,passType);
        },
        beforeDestroy (){
            window.removeEventListener('scroll',this.scrollLoadData);
        },
        components: {
            Loading,
            NoMore
        },
        methods: {
            getRouteData (){
                // 获取用户信息
                // if(this.$route.query.user.mediaHeadPic){
                //  this.userInfo = this.$route.query.user;
                // }
                let that = this;
                getuserinfo().then(result => {
                    if(result.code == '0'){
                      
					}else{
						this.$layer.dialog({
							content: result.message,
							time: 2000
						})
                    }
                    
                    // if(result.code != 1){
                    //     that.$router.push({path: '/Login'})
                    //     return;
                    // }
                    // if (result.user) {
                    //     that.userInfo = result.user;
                    //     if(result.user.registstep != 3){
                    //         that.$router.push({path: '/RegistType'})
                    //     }
                    // }
                })
            },
            canNotView (){
                this.$layer.dialog({
                    content: '暂不支持预览',
                    time: 2000
                })
            },
            popupsLayer (val){
                // console.log(val);
                let that =this;
                if(val.type == 1){
                    this.$layer.footer({
                        content: '确定从主页撤回？',
                        btn: ['取消', '撤回']
                    }).then(function (res){
                        if(res == 1){
                            // console.log('撤回');
                            that.withdrawcontent(val, 1);
                        }
                    })
                }else if(val.type == 3){
                    this.$layer.footer({
                        content: '确定要删除这篇文章吗？',
                        btn: ['取消', '删除']
                    }).then(function (res){
                        if(res == 1){
                            // console.log('删除')
                            that.delcontent(val)
                        }
                    })
                }else if(val.type == 4){
                    this.$layer.footer({
                        content: '请选择操作',
                        btn: ['取消', '删除']
                    }).then(function (res){
                        if(res == 2){
                            console.log('发布')
                        }else if(res == 1){
                            // console.log('删除')
                            that.deldraftlist(val)
                        }
                    })
                }else if(val.type == 5){
                    this.$layer.footer({
                        content: '请选择操作',
                        btn: ['取消', '取消撤回', '删除']
                    }).then(function (res){
                        if(res == 1){
                            // console.log('取消撤回')
                            that.withdrawcontent(val, 0)
                        }else if(res == 2){
                            // console.log('删除')
                            that.delcontent(val)
                        }
                    })
                }
            },
            scrollLoadData (){
                let releaseSelected = document.getElementsByClassName('vue-tab')[this.dataType].getAttribute('aria-selected');
                let searchTxt = document.querySelector('#loadDataByTitle input').value;
                // console.log(document.documentElement.clientHeight+'-----------'+window.innerHeight); // 可视区域高度  
                // console.log(document.body.scrollTop); // 滚动高度  
                // console.log(document.documentElement.scrollTop); // 滚动高度  
                // console.log(document.body.offsetHeight); // 文档高度  
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                let innerHeight = window.innerHeight;
                let offsetHeight = document.body.offsetHeight;
                // 判断是否滚动到底部  
                if(searchTxt == '' && scrollTop + innerHeight >= offsetHeight) { 
                    // 如果开关打开则加载数据  
                    if(this.loadSwitch && !this.noData && releaseSelected == 'true'){
                        pgno++;
                        this.getmaininfo(pgno,passType);
                    }
                }else if(scrollTop + innerHeight >= offsetHeight){
                    if(this.loadSwitch && !this.noData && searchTxt != ''){
                        pgno++;
                        this.searchcontent(pgno,searchTxt);
                    }
                }
            },
            searchcontent (pgno, title){ // 获取近期发布文章数据
                this.loadSwitch = false;
                  let condition = {
                      type:passType,
                      title:title
                  };
                let params = {
                    current: pgno,
                    pageSize: 10,
                    condition:JSON.stringify(condition)
                }
                this.loadingShow = true;
                let that = this;
                if(pgno == 1){
                    this.articleListData = [];
                }
                getmaininfo(params).then( result => {
                    if(result.code == '0'){
                        if(!result.data){
                            that.loadingShow = false;
                            that.noData = true;
                            return false;
                        }else{
                            let maininfoData = result.data.records;
                            let urlidArr = [];
                            for(let i=0;i<maininfoData.length;i++){
                                urlidArr.push(maininfoData[i].urlid);
                            }
                           // urlidArr=urlidArr.join(',');
                            let viewParams={
                               urlIds:urlidArr
                            };
                            getPageview(viewParams).then( res => {
                                if(res.code == '0'){
                                    let pageviewData = res.data;
                                    // console.log(res)
                                    for(let i = 0; i < maininfoData.length; i++){
                                        for(let j = 0; j < pageviewData.length; j++){
                                            if(maininfoData[i].urlid == pageviewData[j].urlid){
                                                maininfoData[i].readpv = pageviewData[j].read_pv;
                                                maininfoData[i].commentpv = pageviewData[j].comment_pv;
                                            }
                                        }
                                        that.articleListData.push(maininfoData[i]);
                                    }
                                    that.loadSwitch = true;
                                }
                            })
                            if(maininfoData.length < 10){
                                that.noData = true;
                            }else{
                                that.noData = false;
                            }
                            that.loadingShow = false;
                        }
                    }
                })
            },
            getmaininfo (pgno, passType){ // 获取近期发布文章数据
                this.loadSwitch = false;
                let condition = {
                      type:passType,
                      title:""
                  };
                let params = {
                    current: pgno,
                    pageSize: 10,
                    condition:JSON.stringify(condition)
                }
                this.loadingShow = true;
                let that = this;
                getmaininfo(params).then( result => {
                    if(result.code == '0'){
                        if(!result.data){
                            that.loadingShow = false;
                            that.noData = true;
                            return false;
                        }else{
                            let maininfoData = result.data.records;
                            let urlidArr = [];
                            for(let i=0;i<maininfoData.length;i++){
                               // if(maininfoData[i].type == '1'){
                                   urlidArr.push(maininfoData[i].urlid);
                              //  }
                               
                            }
                           // urlidArr=urlidArr.join(',');
                            let viewParams={
                                urlIds:urlidArr
                            };
                            getPageview(viewParams).then( res => {
                                if(res.code == '0'){
                                    let pageviewData = res.data;
                                    // console.log(res)
                                    for(let i = 0; i < maininfoData.length; i++){
                                        for(let j = 0; j < pageviewData.length; j++){
                                            if(maininfoData[i].urlid == pageviewData[j].urlid){
                                                maininfoData[i].readpv = pageviewData[j].read_pv;
                                                maininfoData[i].commentpv = pageviewData[j].comment_pv;
                                            }
                                        }
                                        that.articleListData.push(maininfoData[i]);
                                    }
                                    that.loadSwitch = true;
                                }
                            })
                            if(maininfoData.length < 10){
                                that.noData = true;
                            }else{
                                that.noData = false;
                            }
                            that.loadingShow = false;
                        }
                    }
                })
            },
            // 文章撤回操作
            withdrawcontent (val, type){
                let params= {
                    urlId: val.urlid,
                    contentId: val.contentid,
                    addBlack:type,
                    newRowKey: val.newrowkey,
                }
                withdrawcontent(params).then( result => {
                    if(result.code =='0'){
                        this.$layer.dialog({
                            content:"操作成功",
                            btn: ['确定'],
                        }).then(function(){
                            location.reload()
                        })
                    }else{
                        this.$layer.dialog({
                            content: '操作失败，请重新尝试',
                            btn: ['确定'],
                        })
                    }
                })
            },
            // 删除文章操作
            delcontent (val){
                let params= {
                  //  urlid: val.urlid,
                    contentId: val.contentid,
                  //  type: 3,
                }
                delcontent(params).then( result => {
                    if(result.code == '0'){
                        this.$layer.dialog({
                            content: "操作成功",
                            btn: ['确定'],
                        }).then(function(){
                            location.reload()
                        })
                    }else{
                        this.$layer.dialog({
                            content: '操作失败，请重新尝试',
                            btn: ['确定'],
                        })
                    }
                })
            },
            // 删除草稿文章操作
            deldraftlist (val){
                // let params= {
                //     draftid: val.contentid,
                //     type: 3,
                // }
                deldraftlist(val.id).then( result => {
                    if(result.code == '0'){
                        this.$layer.dialog({
                            content: '删除成功',
                            btn: ['确定'],
                        }).then(function(){
                            location.reload()
                        })
                    }else{
                        this.$layer.dialog({
                            content: '操作失败，请重新尝试',
                            btn: ['确定'],
                        })
                    }
                })
            },
        },
        filters:{
			dateFormat:function(val){
				if(val){
					return dateFormat('yyyy-MM-dd hh:mm:ss',new Date(val));
				}

			}
		}
    }
</script>
<style scoped>  
    .art-box{
        max-height: 14rem;
        overflow: auto;
    }  
    #articleList li {
        width: 100%;
        height: 2.4rem;
        background: #fff;
        border-bottom: 1px solid #e1e1e1;
        padding: 0.3rem;
    }

    #articleList li .info {
        width: 4rem;
        float: left;
    }

    #articleList li .info h3 {
        font-size: 0.34rem;
        font-weight: normal;
        line-height: 0.44rem;
        height: 0.88rem;
        overflow: hidden;
    }

    #articleList li .info h3 a {
        display: inline-block;
        color: #333333;
        height: 100%;
        overflow: hidden;
    }

    #articleList li .info p {
        color: #999999;
        font-size: 0.24rem;
        margin: 0.1rem 0;
    }

    #articleList li .info p:last-child {
        color: #999999;
        font-size: 0.28rem;
        margin-bottom: 0;
        margin-top: 0.15rem;
    }
    #articleList li .info p:last-child > span {
        display: inline-block;
        margin-right: 0.2rem;
        overflow: hidden;
    }
    #articleList li .info p:last-child > span span{
        float: left;
        margin-right: 0.1rem;
        font-size: 0.24rem;
    }
    #articleList li .info p .read-icon{
        display: inline-block;
        width: 0.38rem;
        height: 0.38rem;
        background: url('./../../assets/img/read-icon.png') no-repeat center center;
        background-size: 0.38rem 0.38rem;
        position: relative;
        top: -0.028rem;
    }

    #articleList li .info p .comment-icon{
        display: inline-block;
        width: 0.38rem;
        height: 0.38rem;
        background: url('./../../assets/img/comment-icon.png') no-repeat center center;
        background-size: 0.38rem 0.38rem;
        position: relative;
        top: -0.02rem;
    }

    #articleList li .cover-pic {
        float: right;
        width: 2.4rem;
        height: 1.8rem;
    }

    #articleList li .cover-pic img {
        width: 100%;
    }

    #articleList li:last-child {
        margin-bottom: 0
    }

    #articleList li .info p span.operat {
        margin-left: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
        color: #333;
    }
</style>




// WEBPACK FOOTER //
// src/components/pagearticle/articleList.vue